<template>
  <div class="qms-container">
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-link"></i> QMS导航菜单</span>
      </div>
      <div class="link-list">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button type="text" @click="navigateToShipmentTestReport" class="link-button">
              供应商自检报告上传
            </el-button>
          </el-col>
          <el-col :span="24">
            <el-button type="text" @click="navigateToQualityExternal" class="link-button">
              供应商质量改进
            </el-button>
          </el-col>
          <el-col :span="24">
            <el-button type="text" @click="navigateToPreventiveTable" class="link-button">
              供应商绩效改进
            </el-button>
          </el-col>
          <el-col :span="24">
            <el-button type="text" @click="navigateToSupplierAssesTable" class="link-button">
              供应商索赔/考核明细
            </el-button>
          </el-col>
          <el-col :span="24">
            <el-button type="text" @click="navigateToQualityExternalDone" class="link-button">
              供应商质量改进已办列表
            </el-button>
          </el-col>
          <el-col :span="24">
            <el-button type="text" @click="navigateToPreventiveTableDone" class="link-button">
              供方绩效改进已办列表
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { qmsUrlData } from '@/controller/supplier'

export default {
  data() {
    return {
      urlData: '',
      loginName: null // 需要从用户信息中获取
    }
  },
  components: {},
  activated() {
  },
  methods: {

    // 跳转到供应商自检页面
    navigateToShipmentTestReport() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/supplierShipmentTestReport?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },

    // 跳转到供应商质量改进页面
    navigateToQualityExternal() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/supplierQualityExternal?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },

    // 跳转到预防纠正措施页面
    navigateToPreventiveTable() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/supplierPreventiveTable?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },
    navigateToSupplierAssesTable() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/venSupplierAssesTable?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },

    // 跳转到供应商质量改进已办列表页面
    navigateToQualityExternalDone() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/supplierQualityExternalDone?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },

    // 跳转到供方绩效改进已办列表页面
    navigateToPreventiveTableDone() {
      this.getQmsUrlData().then(urlData => {
        if (urlData) {
          const fullUrl = `https://qms.wqnev.com/#/supplierPreventiveTableDone?supplierCode=${urlData}`
          window.open(fullUrl, '_blank')
        }
      })
    },

    // 获取QMS URL数据的通用方法
    getQmsUrlData() {
      return new Promise((resolve, reject) => {
        qmsUrlData({})
            .then(data => {
              if (data && data.code === '00') {
                resolve(data.body)
              } else {
                this.$message.error(data.msg || '获取链接信息失败')
                reject(null)
              }
            })
            .catch(error => {
              this.$message.error('请求失败')
              reject(null)
            })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.qms-container {
  padding: 20px;
}

.link-button {
  display: block;
  width: 100%;
  text-align: left;
  font-size: 16px;
  padding: 15px 0;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    color: #409EFF;
    background-color: #f5f7fa;
  }
}

.clearfix {
  font-weight: bold;
  font-size: 16px;
}
</style>
